import { Outlet } from "react-router-dom";
import SidebarMentor from "../sidebarMentor/Sidebar";

const AppLayoutMentor = () => {
    return <div style={{
        padding: '50px 0px 0px 370px'
    }}>
        <SidebarMentor />
        <Outlet />
    </div>;
};

export default AppLayoutMentor;
